export const CEP_VALIDATOR = /\d{5}-\d{3}/;
export const PHONE_VALIDATOR =
  /^(?:(?:\+|00)?(55)\s?)?(?:\(?([1-9][0-9])\)?\s?)?(?:((?:9\d|[2-9])\d{3})-?(\d{4}))$/;
export const PASSWORD_VALIDATOR =
  /^(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).{4,}$/;
export const NUMBERS_VALIDATOR = /\D/g;
